<div class="container mx-auto px-4 py-8">
  <!-- Page Header -->
  <div class="mb-8">
    <h1 class="text-3xl font-bold text-gray-900 mb-2">Vereine</h1>
    <p class="text-gray-600">Unsere Mitgliedsvereine im Schützenkreis Süd</p>
  </div>

  <!-- Error Message -->
  @if (errorMessage()) {
    <div class="rounded-md bg-red-50 p-4 mb-6">
      <p class="text-sm font-medium text-red-800">{{ errorMessage() }}</p>
    </div>
  }

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="text-center py-12">
      <p class="text-gray-500">Lädt Vereinsdaten...</p>
    </div>
  }

  <!-- Vereine Grid -->
  @if (!isLoading() && vereine().length > 0) {
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      @for (verein of vereine(); track verein.Id) {
        <div class="bg-white rounded-lg shadow hover:shadow-lg transition-shadow duration-300 overflow-hidden">
          <!-- Image -->
          <div class="w-full h-32 bg-gray-100 flex items-center justify-center p-4">
            <img
              [src]="'images/' + verein.ImageFile"
              [alt]="verein.Name"
              class="max-w-full max-h-full object-contain"
            />
          </div>

          <!-- Content -->
          <div class="p-4">
            <!-- Name with optional link -->
            @if (hasUrl(verein)) {
              <a
                [href]="verein.Url"
                target="_blank"
                rel="noopener noreferrer"
                class="block text-center font-semibold text-blue-600 hover:text-blue-800 transition-colors group"
              >
                <span class="group-hover:underline">{{ verein.Name }}</span>
                <svg class="w-4 h-4 inline-block ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                </svg>
              </a>
            } @else {
              <p class="text-center font-semibold text-gray-600">{{ verein.Name }}</p>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Empty State -->
  @if (!isLoading() && vereine().length === 0 && !errorMessage()) {
    <div class="text-center py-12">
      <p class="text-gray-500">Keine Vereine verfügbar</p>
    </div>
  }
</div>
